import React from 'react';
import { Field, reduxForm } from 'redux-form';
import {
  Button,
  Form,
  Grid,
  Header,
  Icon,
  Message,
  Segment,
} from 'semantic-ui-react';

import { ReduxField } from '../';
import asyncValidate from '../../asyncValidate';
import validate from '../../validate';

const SignupForm = props => {
  const { asyncValidating, handleSubmit, submitting, submitFailed } = props;
  return (
    <div className="login-form">
      {/*
            Heads up! The styles below are necessary for the correct render of this example.
            You can do same with CSS, the main idea is that all the elements up to the `Grid`
            below must have a height of 100%.
          */}
      <style>{`
            body > div,
            body > div > div,
            body > div > div > div.login-form {
              height: 100%;
            }
          `}</style>
      <Grid
        textAlign="center"
        style={{ height: '100%' }}
        verticalAlign="middle"
      >
        <Grid.Column textAlign="left" style={{ maxWidth: 450 }}>
          <Header as="h2" color="teal" textAlign="center">
            <Icon name="privacy" />
            Request early Access to private beta
          </Header>
          <Form onSubmit={handleSubmit} size="large">
            <Segment stacked>
              <Field
                name="name"
                type="text"
                component={ReduxField}
                label="Full Name"
              />
              <Field
                name="username"
                type="text"
                loading={true}
                component={ReduxField}
                label="Username"
              />
              <Field
                name="email"
                type="text"
                component={ReduxField}
                label="Email address"
              />
              <Field
                name="password"
                type="password"
                component={ReduxField}
                label="Password"
              />
              <Button
                disabled={
                  submitting || (submitFailed && asyncValidating === true)
                }
                type="submit"
                loading={
                  submitting || (submitFailed && asyncValidating === true)
                }
                fluid
                primary
                size="big"
              >
                Signup
              </Button>
            </Segment>
          </Form>
          <Message>
            Already have an account? <a href="/login">Log in</a>
          </Message>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default reduxForm({
  form: 'signup',
  validate,
  asyncValidate,
  asyncChangeFields: ['username'],
})(SignupForm);



// WEBPACK FOOTER //
// ./src/containers/Signup/components/SignupForm/index.jsx